import { configureStore, combineReducers } from '@reduxjs/toolkit';

// State slice reducers
import userReducer from './features/user/userSlice';
import authReducer from './features/auth/authSlice';
import appReducer from './features/app/appSlice';
import countriesReducer from './features/countries/countriesSlice';
import itemFamiliesReducer from './features/itemFamilies/itemFamiliesSlice';
import itemFamilyReducer from './features/itemFamily/itemFamilySlice';
import itemsReducer from './features/items/itemsSlice';
import itemOwnersReducer from './features/itemOwner/itemOwnersSlice';
import itemReducer from './features/item/itemSlice';
import pinsReducer from './features/pins/pinsSlice';
import snackbarReducer from './features/snackbar/snackbarSlice';
import itemSearchesReducer from './features/itemSearches/itemSearchesSlice';
import itemSearchReducer from './features/itemSearches/itemSearchSlice';
import feedReducer from './features/feeds/feedSlice';
import tyreAwardsReducer from './features/tyreAwards/tyreAwardsSlice';
import wheelsReducer from './features/wheels/wheelsSlice';
import wheelReducer from './features/wheel/wheelSlice';
import treadsReducer from './features/treads/treadsSlice';
import treadReducer from './features/tread/treadSlice';

import { logout } from './features/auth/authSlice';

const combinedReducer = combineReducers({
  app: appReducer,
  auth: authReducer,
  user: userReducer,
  countries: countriesReducer,
  feed: feedReducer,
  itemFamilies: itemFamiliesReducer,
  itemFamily: itemFamilyReducer,
  items: itemsReducer,
  item: itemReducer,
  itemOwners: itemOwnersReducer,
  pins: pinsReducer,
  snackbar: snackbarReducer,
  itemSearches: itemSearchesReducer,
  itemSearch: itemSearchReducer,
  tyreAwards: tyreAwardsReducer,
  wheels: wheelsReducer,
  wheel: wheelReducer,
  treads: treadsReducer,
  tread: treadReducer
});

const rootReducer = (state, action) => {
  // On logout, reset all reducer slices to their initial states
  if(action.type === 'user/logout/fulfilled') {
    state = undefined;
  }
  return combinedReducer(state, action);
};

// If any payload returns 401, force logout
const authInterceptor = ({ dispatch }) => (next) => (action) => {
  if(action.type.indexOf('auth/check') === -1 && action.payload?.code === 401) {
    dispatch(logout());
  } else {
    next(action);
  }
};

export default configureStore({
  reducer: rootReducer,
  middleware: (getDefaultMiddleware) => getDefaultMiddleware().concat(authInterceptor)
});
